<template lang="html">
  <div class='inline-block'>
    <button class='button is-info width-1' @click='forceSyncShow'>强制同步</button>
    <el-dialog title="强制同步" :visible.sync="forceSyncDialogVisible" :before-close="closeForceSyncDialog" width="80%">
      <div>
        <span>天猫商品ID</span>
        <el-tooltip class="item" effect="light" placement="top-end">
          <div slot="content">天猫链接内的ID 商品地址：https://detail.tmall.com/item.htm?id=566714766919<br/>可以使用以上地址，替换id=后面部分，进行确认ID准确性</div>
          <i class="el-icon-warning"></i>
        </el-tooltip>
      </div>
      <div v-for="(item, index) in forceSyncList" class='sync margin-top-10'>
        <el-input v-model="item.thirdPartyGoodsId" size='small' placeholder="请输入商品ID" style='width:150px'></el-input>
        <el-button type="primary" size='small' class='margin-right-50' @click="checkGoods(item.thirdPartyGoodsId, index)">检测</el-button>
        <template v-if="item.isChecked && !item.isExist">
          <label for="">设计师</label>
          <el-select v-model="item.designerId" placeholder="请选择">
            <el-option v-for="item in designerInfo"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        <label for="">一级类目</label>
        <el-select v-model="item.selectedParentCategoryId" placeholder="请选择" @change="parentCategoryChange(item.selectedParentCategoryId, index)">
          <el-option v-for="item in currentParentCategory"
            :key="item.categoryId"
            :label="item.name"
            :value="item.categoryId">
          </el-option>
        </el-select>
        <label for="">二级类目</label>
        <el-select v-model="item.selectedChildCategoryId" placeholder="请选择">
          <el-option v-for="value in item.childCategoryList"
            :key="value.categoryId"
            :label="value.name"
            :value="value.categoryId">
          </el-option>
        </el-select>
      </template>

      <template v-if="item.isChecked && item.isExist">
        商品已经在穿衣后台创建，确认需要同步覆盖后点击【同步】
      </template>
      <template v-if="item.isChecked">
        <el-button v-if="!item.loading && item.isExist" type="primary"  :disabled="!!item.name" @click='forceSync(index)'>同步</el-button>
        <el-button v-if="!item.loading && !item.isExist" type="primary"  :disabled="!!item.name" @click='sync(index)'>同步</el-button>
        <el-button v-if="item.loading" type="primary" icon="el-icon-loading"></el-button>
      </template>
      <div class='goods-info-wrap' v-if='item.name'>
        <a class="clearfix" target="_blank" :href="`https://ai.ichuanyi.com/ai-admin/#/goodsManagement/goodsEdit?goodsId=${item.goodsId}`">{{item.name}}</a>
        <image-component :image="{image:item.picture, widht: 0, height:0}" :width="100"></image-component>
      </div>
    </div>
    <div class="block text-center">
      <el-button type="primary" icon="el-icon-plus" class='width-1 margin-top-10' @click='addForceSyncList'></el-button>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="goToEdit">去编辑</el-button>
      <el-button type="primary" @click="closeForceSyncDialog">关 闭</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui';
export default {
  props: {
    parentCategory: {
      type: Array,
      default() {
        return []
      }
    },
    designerInfo: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      forceSyncList: [
        {
          thirdPartyGoodsId: '',
          isChecked: false,
          isExist: '',
          designerId: '',
          selectedParentCategoryId: '',
          childCategoryList: [],
          selectedChildCategoryId: '',
          loading: false,
          name: '',
          picture: '',
          goodsId: ''
        }
      ],
      forceSyncDialogVisible: false,
      currentParentCategory: [],
      goodsArray: [],
      timer: null,
    }
  },
  mounted() {
    this.currentParentCategory = this.parentCategory
  },
  methods: {
    forceSync(index) {
      let item = this.forceSyncList[index]
      this.forceSyncList[index].loading = true;
      let params = {
        thirdPartyGoodsId: item.thirdPartyGoodsId
      }
      HttpRequest.get('/admin.php?method=shoppingguide.forceImportChuanYiGoods', params).then(() => {
        this.goodsArray.push(item.thirdPartyGoodsId)
        this.getImportProcess()
      }).catch(() => {
        this.forceSyncList[index].loading = false;
      })
    },
    sync(index) {
      let item = this.forceSyncList[index]
      if (!item.designerId || !item.selectedParentCategoryId || !item.selectedChildCategoryId) {
        Message({message:"请选择必选项"})
      } else {
        this.forceSyncList[index].loading = true;
        let params = {
          designerId: item.designerId,
          categoryId: item.selectedParentCategoryId,
          subCategoryId: item.selectedChildCategoryId,
          thirdPartyGoodsId: item.thirdPartyGoodsId
        }
        HttpRequest.get('/admin.php?method=shoppingguide.forceImportChuanYiGoods', params).then(() => {
          this.goodsArray.push(item.thirdPartyGoodsId)
          this.getImportProcess()
        }).catch(() => {
          this.forceSyncList[index].loading = false;
        })
      }
    },
    getImportProcess() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.goodsArray.length == 0) {
            clearInterval(this.timer)
            this.timer = null;
            return;
          }
          HttpRequest.post('/admin.php?method=shoppingguide.getImportProcess',{ goodsArray: this.goodsArray}).then(response => {
            if (response.data) {
              _.each(response.data, (item, index) => {
                if (item.goodsId) {
                  let index = _.findIndex(this.forceSyncList, { thirdPartyGoodsId: item.thirdPartyGoodsId })
                  this.forceSyncList[index].name = item.name;
                  this.forceSyncList[index].picture = item.picture;
                  this.forceSyncList[index].goodsId = item.goodsId;
                  this.forceSyncList[index].loading = false;
                  this.goodsArray.splice(this.goodsArray.indexOf(item.thirdPartyGoodsId), 1);
                }
              })
            }
          })
        }, 3000)
      }
    },
    checkGoods(thirdPartyGoodsId, index) {
      if (!thirdPartyGoodsId) {
        Message({message:"请填写商品ID"})
        return;
      }
      let tempIndex = _.findIndex(this.forceSyncList, { thirdPartyGoodsId })
      if (tempIndex != index) {
        Message({message:"不能填写重复商品ID"})
        return;
      }
      HttpRequest.get('/admin.php?method=shoppingguide.checkGoods', { thirdPartyGoodsId }).then((response) => {
        if (response.data.type == 0) {
          this.forceSyncList[index].isExist = false
        } else if (response.data.type == 1) {
          this.forceSyncList[index].isExist = true
        }
        this.forceSyncList[index].isChecked = true
      })
    },
    addForceSyncList() {
      this.forceSyncList.push({
        thirdPartyGoodsId: '',
        isChecked: false,
        isExist: '',
        designerId: '',
        selectedParentCategoryId: '',
        childCategoryList: [],
        selectedChildCategoryId: '',
        loading: false,
        name: '',
        picture: '',
        goodsId: ''
      })
    },
    parentCategoryChange(categoryId, index) {
      HttpRequest.get('/admin.php?method=goods.getCategoryList', {parentCategoryId: categoryId}).then(response => {
        this.forceSyncList[index].childCategoryList = _.toArray(response.data.list).map((item) => {
          return {
            categoryId: item.categoryId,
            name: item.name
          }
        })
      })
    },
    closeForceSyncDialog() {
      this.forceSyncList = [
        {
          thirdPartyGoodsId: '',
          isChecked: false,
          isExist: '',
          designerId: '',
          selectedParentCategoryId: '',
          childCategoryList: [],
          selectedChildCategoryId: '',
          loading: false,
          name: '',
          picture: '',
          goodsId: ''
        }
      ]
      this.forceSyncDialogVisible = false;
    },
    goToEdit() {
      window.open('https://ai.ichuanyi.com/ai-admin/#/goodsManagement/goodsList')
    },
    //强制同步弹窗显示
    forceSyncShow() {
      this.forceSyncDialogVisible = true;
      if (!this.currentParentCategory.length) {
        HttpRequest.get('/admin.php?method=goods.getCategoryList', {parentCategoryId: 0}).then(response => {
          this.currentParentCategory = _.toArray(response.data.list).map((item) => {
            return {
              categoryId: item.categoryId,
              name: item.name
            }
          })
        })
      }
    },
  }
}
</script>

<style lang="less">
.margin-top-10 {
  margin-top: 10px;
}
.goods-info-wrap {
  display: inline-block;
  vertical-align: top;
}
.margin-right-50 {
  margin-right: 50px;
}
</style>
